// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"335":"bc0cee31","530":"8a8d0513","673":"e3cd795f","931":"c75d39cf","960":"4ae6ee25"}[chunkId] + ".chunk.js";
};